import { useState } from "react";
import { useReveal } from "../hooks";

const FAQS = [
  ["How does payment actually work?", "Our compensation is 100% performance-based. We earn a commission on every sale our reps close for your brand — no retainers, no setup fees, no upfront costs. If we don't sell, you don't pay."],
  ["Who is SwiftMarketing not for?", "Brands that can't fulfill increased volume, one-off products without repeat economics, or offers that don't survive a face-to-face conversation. We'll tell you honestly on the first call if the fit isn't there."],
  ["Is SwiftMarketing the right fit for every company?", "No — and that's by design. We assess fit, unit economics, and fulfillment capacity before deploying a single rep. Because we only get paid on results, we only take partnerships we're confident we can grow."],
  ["I have no sales experience, can I still join the team?", "Absolutely. Most of our top performers started with zero experience. Every new rep goes through Swift's training system — pitch structure, product knowledge, and field coaching — and starts earning from their first close as a BDR."],
  ["How fast can we expect to see results?", "Typically, a pilot team is in the field within 2–4 weeks of signing, with first sales in the opening days. Meaningful, measurable volume usually lands within 30–60 days — our energy division did $300K in its first two months."],
  ["What makes SwiftMarketing different from a typical agency?", "Agencies sell you impressions and reports. We deploy real people who close real sales face-to-face, and we only make money when you do. Full skin in the game, from pitch to signed contract."],
];

export const FAQ = () => {
  const [ref, inView] = useReveal(0.1);
  const [open, setOpen] = useState(0);
  return (
    <section className="sec" id="faq" data-testid="faq-section" ref={ref} style={{ background: "var(--lav)" }}>
      <div className="container">
        <div className={`reveal ${inView ? "in" : ""}`} style={{ textAlign: "center" }}>
          <span className="eyebrow">FAQ</span>
          <h2 className="h-display">Frequently asked questions</h2>
        </div>
        <div className={`faq-list reveal d1 ${inView ? "in" : ""}`}>
          {FAQS.map(([q, a], i) => (
            <div key={i} className={`faq-item ${open === i ? "open" : ""}`} data-testid={`faq-item-${i}`}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} data-testid={`faq-question-${i}`}>
                {q}
                <svg className="plus" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14" /></svg>
              </button>
              <div className="faq-a" style={{ maxHeight: open === i ? 220 : 0 }}>
                <p>{a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const CTA = () => {
  const [ref, inView] = useReveal(0.3);
  return (
    <section className="sec cta" ref={ref} data-testid="cta-section">
      <div className={`container reveal ${inView ? "in" : ""}`}>
        <span className="eyebrow light">Next step</span>
        <h2 className="h-display">Let's generate revenue for you</h2>
        <p className="lead">
          In a short call, we assess fit, economics, and volume potential.
          If it doesn't make sense, we'll tell you. No obligations.
        </p>
        <a href="#qualify" className="btn" data-testid="cta-qualify-btn">Check if You Qualify</a>
      </div>
    </section>
  );
};

export const Footer = () => (
  <footer className="footer" data-testid="footer">
    <div className="container">
      <div className="footer-grid">
        <div>
          <div className="footer-logo">Swift<span>Marketing</span></div>
          <p style={{ fontSize: 14, maxWidth: 260, lineHeight: 1.6, marginTop: 14 }}>
            Performance-based sales consulting. We build, deploy, and manage the teams
            that grow your brand.
          </p>
        </div>
        <div className="footer-col">
          <h5>Divisions</h5>
          <a href="#services">Telecom &amp; B2B</a>
          <a href="#energy">Swift Energy — HVAC</a>
          <a href="#careers">Careers</a>
        </div>
        <div className="footer-col">
          <h5>Explore</h5>
          <a href="#results">Case studies</a>
          <a href="#calculator">Revenue calculator</a>
          <a href="#faq">FAQ</a>
        </div>
        <div className="footer-col">
          <h5>Contact</h5>
          <p>Montreal, QC</p>
          <a href="mailto:info@swiftmarketing.ca" data-testid="footer-email">info@swiftmarketing.ca</a>
          <a href="tel:+14384832144" data-testid="footer-phone">+1 438 483-2144</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} SwiftMarketing. All rights reserved.</span>
        <span className="tag">WE SELL. YOU SCALE.</span>
      </div>
    </div>
  </footer>
);
